{
  "MACROS": {
    "HEADER": "Macros",
    "DESCRIPTION": "A macro is a set of saved actions that help customer service agents easily complete tasks. The agents can define a set of actions like tagging a conversation with a label, sending an email transcript, updating a custom attribute, etc., and they can run these actions in a single click.",
    "LEARN_MORE": "Learn more about macros",
    "COUNT": "{n} macro | {n} macros",
    "HEADER_BTN_TXT": "Add a new macro",
    "HEADER_BTN_TXT_SAVE": "Save macro",
    "LOADING": "Fetching macros",
    "SEARCH_PLACEHOLDER": "Search macros...",
    "NO_RESULTS": "No macros found matching your search",
    "ERROR": "Something went wrong. Please try again",
    "ORDER_INFO": "Macro sẽ chạy theo thứ tự hành động của bạn. Bạn có thể sắp xếp lại chúng bằng cách kéo chúng bằng tay cầm bên cạnh mỗi nút.",
    "ADD": {
      "FORM": {
        "NAME": {
          "LABEL": "Tên Macro",
          "PLACEHOLDER": "Nhập tên cho macro của bạn",
          "ERROR": "Cần có tên để tạo macro"
        },
        "ACTIONS": {
          "LABEL": "Hành động"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Đã thêm macro thành công",
        "ERROR_MESSAGE": "Không thể tạo macro, vui lòng thử lại sau"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Tên",
        "CREATED BY": "Tạo bởi",
        "LAST_UPDATED_BY": "Cập nhật lần cuối bởi",
        "VISIBILITY": "Hiển thị",
        "ACTIONS": "Hành động"
      },
      "404": "Không tìm thấy macro"
    },
    "DELETE": {
      "TOOLTIP": "Xóa Macro",
      "CONFIRM": {
        "MESSAGE": "Bạn có muốn xoá? ",
        "YES": "Có, Xoá",
        "NO": "Không"
      },
      "API": {
        "SUCCESS_MESSAGE": "Xóa Macro thành công",
        "ERROR_MESSAGE": "Đã xảy ra lỗi khi xóa macro. Vui lòng thử lại sau"
      }
    },
    "VIEW": {
      "TOOLTIP": "View macro"
    },
    "EDIT": {
      "TOOLTIP": "Sửa Macro",
      "API": {
        "SUCCESS_MESSAGE": "Đã cập nhật macro thành công",
        "ERROR_MESSAGE": "Không thể cập nhật Macro, vui lòng thử lại sau"
      }
    },
    "EDITOR": {
      "START_FLOW": "Bắt đầu quy trình",
      "END_FLOW": "Kết thúc quy trình",
      "LOADING": "Đang tìm nạp macro",
      "ADD_BTN_TOOLTIP": "Thêm hành động mới",
      "DELETE_BTN_TOOLTIP": "Xóa hành động",
      "VISIBILITY": {
        "LABEL": "Hiển thị Macro",
        "GLOBAL": {
          "LABEL": "Công khai",
          "DESCRIPTION": "Macro này có sẵn công khai cho tất cả các tác nhân trong tài khoản này.",
          "CREATE_DISABLED_DESCRIPTION": "Only administrators can create public macros.",
          "EDIT_DISABLED_DESCRIPTION": "Only administrators can edit public macros."
        },
        "PERSONAL": {
          "LABEL": "Riêng tư",
          "DESCRIPTION": "Macro này sẽ là riêng tư đối với bạn và không có sẵn đối với những người khác."
        }
      }
    },
    "EXECUTE": {
      "BUTTON_TOOLTIP": "Thực thi",
      "PREVIEW": "Xem trước Macro",
      "EXECUTED_SUCCESSFULLY": "Macro được thực thi thành công"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Giá trị bắt buộc có",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTIONS": {
      "ASSIGN_TEAM": "Assign a Team",
      "ASSIGN_AGENT": "Assign an Agent",
      "ADD_LABEL": "Add a Label",
      "REMOVE_LABEL": "Remove a Label",
      "REMOVE_ASSIGNED_AGENT": "Remove Assigned Agent",
      "REMOVE_ASSIGNED_TEAM": "Remove Assigned Team",
      "SEND_EMAIL_TRANSCRIPT": "Send an Email Transcript",
      "MUTE_CONVERSATION": "Tắt tiếng cuộc trò chuyện",
      "SNOOZE_CONVERSATION": "Tạm dừng \bhội thoại",
      "RESOLVE_CONVERSATION": "Giải quyết cuộc trò chuyện",
      "SEND_ATTACHMENT": "Send Attachment",
      "SEND_MESSAGE": "Send a Message",
      "CHANGE_PRIORITY": "Change Priority",
      "ADD_PRIVATE_NOTE": "Add a Private Note",
      "SEND_WEBHOOK_EVENT": "Send Webhook Event"
    },
    "PRIORITY_TYPES": {
      "NONE": "Không có",
      "LOW": "Thấp",
      "MEDIUM": "Trung bình",
      "HIGH": "Cao",
      "URGENT": "Cấp bách"
    }
  }
}
